// © Microsoft Corporation. All rights reserved.

import { initializeHybridPublicPath } from "@msnews/core";

initializeHybridPublicPath();